import type { ValueOf } from '#layers/base/types/utils';

export const UserStatus = {
	Active: 'active',
	Suspended: 'suspended',
} as const;

export type UserStatus = ValueOf<typeof UserStatus>;
